import { Status } from 'domains/models/form/status';
import { FormType } from 'domains/models/form/formType';
import { DisplayType } from 'domains/models/form/displayType';
import { HostAssignType } from 'domains/models/form/hostAssignType';
import { HostOperationType } from 'domains/models/form/hostOperationType';
import { MailSenderType } from 'domains/models/form/mail_sender_type';
import { ListViewType } from 'domains/models/form/listViewType';
import { VisualViewType } from 'domains/models/form/visualViewType';
import { RoundRobinAllocateType } from 'domains/models/form/roundRobinAllocateType';
import { z } from 'zod';

export const FormTypeEnum = z.nativeEnum(FormType);
export const HostOperationTypeEnum = z.nativeEnum(HostOperationType);
export const StatusEnum = z.nativeEnum(Status);
export const DisplayTypeEnum = z.nativeEnum(DisplayType);
export const MailSenderTypeEnum = z.nativeEnum(MailSenderType);
export const ListViewTypeEnum = z.nativeEnum(ListViewType);
export const VisualViewTypeEnum = z.nativeEnum(VisualViewType);
export const RoundRobinAllocateTypeEnum = z.nativeEnum(RoundRobinAllocateType);
export const HostAssignTypeEnum = z.nativeEnum(HostAssignType);
